import React from 'react';
import { Bike, Bus, Car, CarTaxiFront, Layers, Lock, Truck, Caravan, Zap } from 'lucide-react';
import { PageHeader } from '../../components/common/PageHeader';
import { Panel } from '../../components/common/Panel';
import { StatusBadge } from '../../components/common/StatusBadge';
const future = [{
  icon: Car,
  bn: 'ব্যক্তিগত গাড়ি',
  en: 'Private Car',
  prefix: 'CAR-'
}, {
  icon: Bus,
  bn: 'বাস',
  en: 'Bus',
  prefix: 'BUS-'
}, {
  icon: Truck,
  bn: 'ট্রাক',
  en: 'Truck',
  prefix: 'TRK-'
}, {
  icon: Caravan,
  bn: 'অন্যান্য যানবাহন',
  en: 'Other Motor Vehicles',
  prefix: 'OTH-'
}];
export function Expansion() {
  return <div className="space-y-4" data-id="element-3725" data-mp="34xt2ghbl1jot">
      <PageHeader title="ভবিষ্যৎ সম্প্রসারণ" subtitle="Future Expansion — একই প্ল্যাটফর্ম, মডিউলভিত্তিক সম্প্রসারণ। নিচের যানবাহনগুলো বর্তমান পর্যায়ের অংশ নয়।" data-id="element-3726" data-mp="350ypzs4kcdif" />
      <Panel data-id="element-3727" data-mp="k7liei68o9c2">
        <StatusBadge tone="green" data-id="element-3728" data-mp="k83m1zv8dpu0">বর্তমান পর্যায় — চলমান</StatusBadge>
        <div className="mt-3 grid gap-3 md:grid-cols-3" data-id="element-3729" data-mp="o8xaqvghz8ny">
          {[{
          icon: CarTaxiFront,
          name: 'সিএনজি অটোরিকশা',
          count: 'প্রায় ১৭,০০০',
          prefix: 'CNG-'
        }, {
          icon: Zap,
          name: 'ব্যাটারিচালিত অটোরিকশা',
          count: '৩-৭ লক্ষ',
          prefix: 'ATR-'
        }, {
          icon: Bike,
          name: 'মোটরসাইকেল',
          count: 'প্রায় ১ লক্ষ',
          prefix: 'MCL-'
        }].map(v => <div key={v.name} className="flex items-center gap-4 rounded-lg border-2 border-bdgreen-600 bg-bdgreen-50 p-4" data-id="element-3730" data-mp="18c45s9nd79xe">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-bdgreen-600 text-white" data-id="element-3731" data-mp="13d9nr9x81pec"><v.icon className="h-7 w-7" data-id="element-3732" data-mp="ykzrlc5ijt3m" /></span>
              <div data-id="element-3733" data-mp="tmoij3n1lmmg">
                <p className="font-heading text-lg font-bold text-navy-900" data-id="element-3734" data-mp="tlwvwibfaz8b">{v.name}</p>
                <p className="text-sm text-slate-600" data-id="element-3735" data-mp="oo3qvsluwb9m">{v.count} • QR প্রিফিক্স <span className="font-mono" data-id="element-3736" data-mp="olimowy35j8p">{v.prefix}</span></p>
              </div>
            </div>)}
        </div>
        <p className="mb-3 mt-6 text-sm font-semibold text-slate-500" data-id="element-3737" data-mp="fn5kj3ny3rnv">পরবর্তী পর্যায়</p>
        <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4" data-id="element-3738" data-mp="5zb3g2nr1112">
          {future.map(f => <div key={f.en} className="relative rounded-lg border border-dashed border-slate-300 bg-white p-4 text-center" data-id="element-3739" data-mp="a0wnc7ypafkr">
              <Lock className="absolute right-3 top-3 h-3.5 w-3.5 text-slate-300" data-id="element-3740" data-mp="3s71c2ljr0mei" />
              <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-slate-100 text-slate-500" data-id="element-3741" data-mp="zyhdk4pbxzj"><f.icon className="h-6 w-6" strokeWidth={1.6} data-id="element-3742" data-mp="op9biirjqu4p" /></span>
              <p className="mt-2 font-semibold text-navy-900" data-id="element-3743" data-mp="os5925zhfgsm">{f.bn}</p>
              <p className="text-xs text-slate-500" data-id="element-3744" data-mp="tocjaaywvegd">{f.en}</p>
              <p className="mt-2 font-mono text-[11px] text-slate-400" data-id="element-3745" data-mp="f0hkqdy82fvd">{f.prefix}000001</p>
              <StatusBadge tone="gray" className="mt-2" data-id="element-3746" data-mp="jyj5d3baqn8y">পরিকল্পিত</StatusBadge>
            </div>)}
        </div>
      </Panel>
      <Panel title="সম্প্রসারণযোগ্য স্থাপত্য" subtitle="নতুন যানবাহন যুক্ত করতে মূল সিস্টেম পরিবর্তনের প্রয়োজন নেই" data-id="element-3747" data-mp="17nvek36mivb9">
        <div className="grid gap-3 md:grid-cols-3" data-id="element-3748" data-mp="1cgohqmmg1vl8">
          {[['যানবাহন ধরন মাস্টার', 'নতুন যানবাহন ধরন, QR প্রিফিক্স ও প্রয়োজনীয় ডকুমেন্ট কনফিগারেশনের মাধ্যমে যুক্ত'], ['অভিন্ন BRTA ইন্টিগ্রেশন', 'একই Vehicle Registration, Fitness, Tax ও License API সকল যানবাহনের জন্য ব্যবহারযোগ্য'], ['একই মোবাইল অ্যাপ', 'ট্রাফিক পুলিশ একই অ্যাপে যেকোনো যানবাহনের QR স্ক্যান করবেন — ফলাফল ধরনভেদে প্রদর্শিত']].map(([t, d]) => <div key={t} className="rounded-md border border-border p-4" data-id="element-3749" data-mp="2e7y1xr6tjq3d">
              <Layers className="h-5 w-5 text-navy-700" data-id="element-3750" data-mp="298d2lfnqlfq4" />
              <p className="mt-2 font-semibold text-navy-900" data-id="element-3751" data-mp="299wktbsye0uj">{t}</p>
              <p className="mt-1 text-sm text-slate-600" data-id="element-3752" data-mp="2n8e48xbtsr6n">{d}</p>
            </div>)}
        </div>
      </Panel>
    </div>;
}